const typography = (muiTheme) => ({
  fontFamily: 'Flama-Book',
  body1: {
    fontFamily: 'Flama-Book',
    fontSize: 18,
    [muiTheme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  body2: {
    fontFamily: 'Flama-Book',
    fontSize: 15,
    [muiTheme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  h1: {
    paddingBottom: 8,
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    fontSize: 28,
  },
  h2: {
    paddingBottom: 8,
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    fontSize: 48,
    [muiTheme.breakpoints.down('sm')]: {
      fontSize: 22,
      fontFamily: 'Flama-Book',
    },
  },
  h3: {
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    fontSize: 18,
  },
  h4: {
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    fontSize: 16,
    [muiTheme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  h5: {
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    fontSize: 14,
    [muiTheme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  h6: {
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    fontSize: 12,
    [muiTheme.breakpoints.down('sm')]: {
      fontFamily: 'Flama-Book',
      fontSize: 10,
    },
  },
  overline: {
    fontFamily: 'Flama-Book',
    fontSize: 12,
  },
  subtitle1: {
    fontFamily: 'Flama-Book',
    fontSize: 11,
  },
  subtitle2: {
    fontFamily: 'Flama-Book',
    fontWeight: 800,
    color: '#000',
    fontSize: 11,
  },
  caption: {
    fontFamily: 'Flama-Book',
    fontSize: 11,
  },
}
);

export default typography;
